(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".readmore-wrapper").forEach(wrapper => {
      const content = wrapper.querySelector(".readmore-content");
      const readMore = wrapper.querySelector(".readmore-btn");
      const readLess = wrapper.querySelector(".readless-btn");
      const buttonWrapper = wrapper.querySelector(".readmore-buttons");

      // Detect if truncation is needed (optional)
      const isOverflowing = content.scrollHeight > content.clientHeight;

      if (!isOverflowing) {
        readMore.style.display = "none";
        readLess.style.display = "none";
        buttonWrapper.style.display = "none";
        wrapper.style.minHeight="unset"
        return;
      }

      readMore.addEventListener("click", () => {
        content.classList.add("expanded");
        readMore.style.display = "none";
        readLess.style.display = "inline-block";
      });

      readLess.addEventListener("click", () => {
        content.classList.remove("expanded");
        readLess.style.display = "none";
        readMore.style.display = "inline-block";
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
